import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

class IGGrabedPostService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/igGrabedPost'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/igGrabedPost', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/igGrabedPost/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/igGrabedPost/${id}`)
    }

    this.apis.embed = (payload) => axios.post(APIConfig.BPIURL + '/igGrabedPost/embed', payload)
    this.apis.sync = (payload) => axios.post(APIConfig.BPIURL + '/igGrabedPost/sync', payload)
    this.apis.getEmbedHTML = (payload) => axios.post(APIConfig.BPIURL + '/igGrabedPost/getEmbedHTML', payload)

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  embed (vm, payload) {
    vm.isLoading = true
    return this.apis.embed(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  sync (vm, payload) {
    vm.isLoading = true
    return this.apis.sync(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  getEmbedHTML (vm, payload) {
    vm.isLoading = true
    return this.apis.getEmbedHTML(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
export default IGGrabedPostService
